import { useEffect, useState } from "react";

import hostCapture from "../liveTap/hostCapture/hostCapture";

// The live snapshot of the host-audio capture (TT-1102) — level, elapsed,
// state — for the capture bar. Ticks with the meter, ~10 Hz while running.
export default function useHostCapture() {
  const [snapshot, setSnapshot] = useState(() => hostCapture.snapshot());
  useEffect(() => hostCapture.subscribe(setSnapshot), []);
  return snapshot;
}

// Just "is this tab capturing for docId" — for the page, which must not
// re-render with the meter.
export function useHostCaptureActive(docId) {
  const [active, setActive] = useState(() => hostCapture.isCapturing(docId));
  useEffect(
    () =>
      hostCapture.subscribe((snap) => {
        setActive(snap.active && (!docId || snap.docId === docId));
      }),
    [docId]
  );
  return active;
}
